import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.company.review');
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ClassicEditor, createCKEditorConfig } from "src/libs/portal/season/ckeditor";

@Component({
    selector: 'wiz-page-company-review',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.company.review/view.scss */
:host {
  display: block;
  min-height: 100%;
}

:host ::ng-deep .question-rich-editor + .ck-editor .ck-editor__editable,
:host ::ng-deep .ck-editor .ck-editor__editable {
  min-height: 180px;
  font-size: 14px;
  line-height: 1.65;
}

:host ::ng-deep .ck-content img {
  max-width: 100%;
  height: auto;
}`],
})
export class PageCompanyReviewComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private host: ElementRef) { }

    public token: string = '';
    public loading: boolean = true;
    public uploading: boolean = false;
    public submitted: boolean = false;
    public error: string = '';
    public company: any = null;
    public request: any = null;
    public documents: any[] = [];
    public questions: any[] = [];
    private questionEditors: any = {};
    private editorTimer: any = null;
    private editorToolbar: any[] = [
        'heading', '|',
        'fontSize', 'fontColor', 'fontBackgroundColor', '|',
        'bold', 'italic', 'underline', 'strikethrough', '|',
        'alignment', 'bulletedList', 'numberedList', 'todoList', '|',
        'link', 'uploadImage', 'insertTable', 'blockQuote', 'horizontalLine', '|',
        'undo', 'redo'
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.loading.hide();
        this.token = WizRoute.segment.token || '';
        if (!this.token) {
            this.error = '유효하지 않은 링크입니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        await this.load();
    }

    public ngOnDestroy() {
        this.destroyQuestionEditors(true);
    }

    public async load() {
        const { code, data } = await wiz.call('verify', { token: this.token });
        if (code !== 200) {
            this.error = data?.message || '요청 정보를 확인할 수 없습니다.';
            this.loading = false;
            await this.service.render();
            return;
        }
        this.company = data.data.company;
        this.request = data.data.request;
        this.documents = this.request.document_items || [];
        this.questions = this.request.questions || [];
        this.normalizeShareholderDocs();
        this.submitted = this.isSubmittedState(this.request);
        this.loading = false;
        await this.service.render();
        this.scheduleQuestionEditors();
    }

    public async uploadDocument(doc: any) {
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        this.uploading = true;
        await this.service.render();
        const fd = new FormData();
        fd.append('upload', files[0]);
        try {
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            doc.file_url = url;
            doc.file_name = files[0].name;
        } catch (e) {
            this.service.alert.error('파일 업로드에 실패했습니다.');
        }
        this.uploading = false;
        await this.service.render();
    }

    public async submit() {
        this.syncQuestionEditors();
        this.normalizeShareholderDocs();
        const shareholderError = this.validateShareholderDocs();
        if (shareholderError) {
            this.service.alert.error(shareholderError);
            return;
        }
        const missingDoc = this.documents.find((d: any) => d.required && !this.docSubmitted(d));
        if (missingDoc) {
            this.service.alert.error(`필수 서류를 업로드하거나 입력해 주세요: ${missingDoc.title}`);
            return;
        }
        const pendingDoc = this.documents.find((d: any) => d.rerequest_status === 'pending' && (!this.docSubmitted(d) || (d.file_url && d.file_url === d.rerequest_file_url && !this.hasShareholderRows(d))));
        if (pendingDoc) {
            this.service.alert.error(`재요청된 파일을 새로 업로드해 주세요: ${pendingDoc.title}`);
            return;
        }
        const missingQuestion = this.questions.find((q: any) => q.required && !this.hasAnswer(q.answer));
        if (missingQuestion) {
            this.service.alert.error('필수 질문에 답변해 주세요.');
            return;
        }
        const pendingQuestion = this.questions.find((q: any) => q.rerequest_status === 'pending' && (!this.hasAnswer(q.answer) || q.answer === q.rerequest_answer));
        if (pendingQuestion) {
            this.service.alert.error('재요청된 답변을 수정해 주세요.');
            return;
        }
        const { code, data } = await wiz.call('submit', {
            token: this.token,
            data: JSON.stringify({ document_items: this.documents, questions: this.questions })
        });
        if (code !== 200) {
            this.service.alert.error(data?.message || '제출에 실패했습니다.');
            return;
        }
        this.request = data.data;
        this.documents = this.request.document_items || [];
        this.questions = this.request.questions || [];
        this.normalizeShareholderDocs();
        this.submitted = this.isSubmittedState(this.request);
        if (this.submitted) this.destroyQuestionEditors(false);
        await this.service.render();
        this.scheduleQuestionEditors();
    }

    public isSubmittedState(request: any) {
        return request?.status === 'submitted' && !request?.has_pending_rerequests;
    }

    public hasPendingRerequests() {
        return !!this.request?.has_pending_rerequests;
    }

    public isPending(item: any) {
        return item?.rerequest_status === 'pending';
    }

    public historyCount(item: any, key: string) {
        const list = item?.[key];
        return Array.isArray(list) ? list.length : 0;
    }

    public historyList(item: any, key: string) {
        const list = item?.[key];
        return Array.isArray(list) ? list : [];
    }

    public uploadButtonLabel(doc: any) {
        if (this.isPending(doc)) return doc.file_url && doc.file_url !== doc.rerequest_file_url ? '새 파일 선택됨' : '재업로드';
        return doc.file_url ? '파일 교체' : '파일 업로드';
    }

    public isShareholderDoc(doc: any): boolean {
        const text = `${doc?.id || ''} ${doc?.title || ''} ${doc?.description || ''}`.toLowerCase();
        return text.indexOf('doc_shareholder') >= 0 || text.indexOf('shareholder') >= 0 || text.indexOf('주주명부') >= 0 || text.indexOf('캡테이블') >= 0;
    }

    public shareholderRows(doc: any): any[] {
        if (!this.isShareholderDoc(doc)) return [];
        if (!Array.isArray(doc.shareholders)) doc.shareholders = [];
        return doc.shareholders;
    }

    public docSubmitted(doc: any): boolean {
        if (doc?.file_url) return true;
        return this.isShareholderDoc(doc) && this.hasShareholderRows(doc);
    }

    public hasShareholderRows(doc: any): boolean {
        return this.shareholderRows(doc).some((row: any) => {
            return String(row?.name || row?.fund_name || '').trim()
                || String(row?.personal_id_prefix || '').trim()
                || String(row?.business_registed_number || '').trim()
                || this.numberValue(row?.share_count) > 0;
        });
    }

    public addShareholderRow(doc: any) {
        this.shareholderRows(doc).push({
            name: '',
            personal_id_prefix: '',
            business_registed_number: '',
            gender_code: '',
            share_type: '보통주',
            share_count: 0,
            share_ratio: 0,
            round: '',
            acquired_date: '',
            acquisition_price: 0,
            note: ''
        });
        this.recalcShareholderRatio(doc);
        this.service.render();
    }

    public removeShareholderRow(doc: any, index: number) {
        this.shareholderRows(doc).splice(index, 1);
        this.recalcShareholderRatio(doc);
        this.service.render();
    }

    public recalcShareholderRatio(doc: any) {
        const rows = this.shareholderRows(doc);
        const total = rows.reduce((sum: number, row: any) => sum + this.numberValue(row.share_count), 0);
        for (const row of rows) {
            row.share_ratio = total > 0 ? Math.round(this.numberValue(row.share_count) / total * 10000) / 100 : 0;
        }
    }

    public totalShareCount(doc: any): number {
        return this.shareholderRows(doc).reduce((sum: number, row: any) => sum + this.numberValue(row.share_count), 0);
    }

    public formatNumber(value: any): string {
        return Math.round(this.numberValue(value)).toLocaleString('ko-KR');
    }

    public onlyDigits(value: any): string {
        return String(value || '').replace(/[^0-9]/g, '');
    }

    public shareholderIdentityMissing(row: any): boolean {
        return !this.onlyDigits(row?.personal_id_prefix) && !this.onlyDigits(row?.business_registed_number);
    }

    public validateShareholderDocs(): string {
        for (const doc of this.documents || []) {
            if (!this.isShareholderDoc(doc)) continue;
            const rows = this.shareholderRows(doc).filter((row: any) => {
                return String(row?.name || row?.fund_name || '').trim()
                    || String(row?.personal_id_prefix || '').trim()
                    || String(row?.business_registed_number || '').trim()
                    || this.numberValue(row?.share_count) > 0;
            });
            for (let i = 0; i < rows.length; i++) {
                if (this.shareholderIdentityMissing(rows[i])) {
                    return `주주명부 ${i + 1}번째 행의 생년월일 앞자리 또는 사업자등록번호를 입력해 주세요.`;
                }
            }
        }
        return '';
    }

    private numberValue(value: any): number {
        if (value === null || value === undefined || value === '') return 0;
        if (typeof value === 'string') value = value.replace(/,/g, '').trim();
        const num = Number(value);
        return Number.isFinite(num) ? num : 0;
    }

    private normalizeShareholderDocs() {
        for (const doc of this.documents || []) {
            if (!this.isShareholderDoc(doc)) continue;
            if (!Array.isArray(doc.shareholders)) doc.shareholders = [];
            this.recalcShareholderRatio(doc);
        }
    }

    public hasAnswer(value: any) {
        return this.answerText(value).length > 0;
    }

    public answerText(value: any) {
        const div = document.createElement('div');
        div.innerHTML = String(value || '');
        return (div.textContent || div.innerText || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
    }

    private scheduleQuestionEditors() {
        if (this.editorTimer) clearTimeout(this.editorTimer);
        if (this.loading || this.error || this.submitted) return;
        this.editorTimer = setTimeout(() => this.initQuestionEditors(), 0);
    }

    private questionById(id: string) {
        return this.questions.find((q: any) => String(q.id) === String(id));
    }

    private async initQuestionEditors() {
        const elements = this.host?.nativeElement?.querySelectorAll('.question-rich-editor[data-question-id]') || [];
        const active: any = {};
        for (const element of Array.from(elements) as any[]) {
            const id = element.getAttribute('data-question-id');
            const question = this.questionById(id);
            if (!id || !question) continue;
            active[id] = true;
            if (this.questionEditors[id]) continue;

            const editor = await ClassicEditor.create(element, createCKEditorConfig({ toolbar: this.editorToolbar }));
            editor.data.set(question.answer || '');
            editor.model.document.on('change:data', () => {
                const target = this.questionById(id);
                if (target) target.answer = editor.data.get();
            });
            this.questionEditors[id] = editor;
        }

        for (const id of Object.keys(this.questionEditors)) {
            if (!active[id]) this.destroyQuestionEditor(id, true);
        }
    }

    private syncQuestionEditors() {
        for (const id of Object.keys(this.questionEditors)) {
            const question = this.questionById(id);
            if (question) question.answer = this.questionEditors[id].data.get();
        }
    }

    private destroyQuestionEditor(id: string, readData: boolean = true) {
        const editor = this.questionEditors[id];
        if (!editor) return;
        if (readData) {
            const question = this.questionById(id);
            if (question) question.answer = editor.data.get();
        }
        try { editor.destroy(); } catch (e) { }
        delete this.questionEditors[id];
    }

    private destroyQuestionEditors(readData: boolean = true) {
        if (this.editorTimer) {
            clearTimeout(this.editorTimer);
            this.editorTimer = null;
        }
        for (const id of Object.keys(this.questionEditors)) {
            this.destroyQuestionEditor(id, readData);
        }
    }
}

export default PageCompanyReviewComponent;